(function () {
  'use strict';
  var Push = require('push.js/bin/push.min.js'); // Common.js

  angular.module('obex').
  factory('pushService', ['$http', '$q', '$window', 'obexConstant',
    function ($http, $q, $window, obexConstant) {
      return Push;
    },
	]);
})();


// WEBPACK FOOTER //
// ./client/js/services/pushService.js